import type { Action, Thunk } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { StoreModel } from '..';
import type { Injections } from '../services/injections';
import type { ApplicationErrorOptions } from '../../types';
import type { ServiceLevelIdicatorWithHistory, ServiceStatusParams } from '../services/ApiStatusService/types';

export interface ServiceStatusModel {
  // data
  serviceStatusCollection: ServiceLevelIdicatorWithHistory[];
  lastAction?: number;
  // Status
  fetchServiceStatus: Thunk<
    ServiceStatusModel,
    ServiceStatusParams,
    Injections,
    StoreModel,
    Promise<ServiceLevelIdicatorWithHistory[] | undefined>
  >;
  fetchServiceStatusFailure: Action<ServiceStatusModel, ApplicationErrorOptions>;
  setServiceStatus: Action<ServiceStatusModel, ServiceLevelIdicatorWithHistory[]>;
  serviceStatusActionStart: Action<ServiceStatusModel, void>;
}

export const serviceStatusModel: ServiceStatusModel = {
  serviceStatusCollection: [],
  setServiceStatus: action((state, payload) => {
    state.serviceStatusCollection = payload;
  }),
  fetchServiceStatusFailure: action((state, error) => {
    console.error(error);
  }),
  serviceStatusActionStart: action((state) => {
    state.lastAction = Date.now();
  }),
  fetchServiceStatus: thunk(async (actions, payload, { injections }) => {
    try {
      actions.serviceStatusActionStart();
      const { apiStatusService } = injections;
      const response = await apiStatusService.fetchApiStatus(payload);
      actions.setServiceStatus(response);
      return response;
    } catch (error) {
      actions.fetchServiceStatusFailure({
        error,
        message: 'An error occured fetching service status.',
        asNotification: true,
      });
    }
  }),
};
